module.exports = __webpack_public_path__ + "prod/1.42.2/img/api-six.e5e2ebb7.png";